import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	allLists: [],
	loadingListService: true,
};


const produtoSlice = createSlice({
	name: 'produto',
	initialState,
	reducers: {
    setLoading: (state, action) => {
			state.loadingListService = action.payload;
		},
    successProdutoList: (state, action) => {
			state.allLists = action.payload;
		}
  }
});

export const {	
  setLoading,
	successProdutoList
} = produtoSlice.actions;

export default produtoSlice.reducer;